import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function PhasePlotGrid({ projectId, phaseId, plotCount, isNew = false, data }) {
  const [plotData, setPlotData] = useState({});
  const [numberOfPlots, setNumberOfPlots] = useState(0);
  const plots = Array.from({ length: numberOfPlots }, (_, index) => (index + 1 < 10 ? "0" + (index + 1) : index + 1));
  useEffect(() => {
    setPlotData(data);
    setNumberOfPlots(plotCount);
  }, [data, plotCount]);

  const getPlotStatus = (index) => {
    if (plotData?.ongoing_plots?.includes(index + 1)) return "status_on-going";
    if (plotData?.completed_plots?.includes(index + 1)) return "status_completed";
    if (plotData?.available_plots?.includes(index + 1)) return "status_available";
    if (plotData?.canceled_plots?.includes(index + 1)) return "status_canceled";
    if (plotData?.on_hold_plots?.includes(index + 1)) return "status_on-hold";
    if (plotData?.unavailable_plots?.includes(index + 1)) return "status_unavailable";

    return "status_unchecked";
  };
  return (
    <>
      <div className="card plot_grid">
        {plots.map((plot, index) =>
          isNew ? (
            <div key={index} className={`plot ${getPlotStatus(index)}`}>
              #{plot}
            </div>
          ) : (
            <Link
              to={`/project-listing/project/${projectId}/phase/${phaseId}/plot/${index + 1}`}
              key={index}
              className={`plot ${getPlotStatus(index)}`}
            >
              #{index + 1 < 10 ? "0" + (index + 1) : index + 1}
            </Link>
          )
        )}
      </div>
      <div className="row center">
        <div className={isNew ? "plot_swatch_wrapper_new" : "plot_swatch_wrapper"}>
          {!isNew && (
            <>
              <div className="label">
                <div className="color_swatch status_on-going"></div>
                <span className="label">On Going</span>
              </div>
              <div className="label">
                <div className="color_swatch status_canceled"></div>
                <span className="label">Cancelled</span>
              </div>
              <div className="label">
                <div className="color_swatch status_on-hold"></div>
                <span className="label">On Hold</span>
              </div>
              <div className="label">
                <div className="color_swatch status_completed"></div>
                <span className="label">Completed</span>
              </div>
            </>
          )}
          <div className="label">
            <div className="color_swatch status_available"></div>
            <span className="label">Available</span>
          </div>
          <div className="label">
            <div className="color_swatch status_unavailable"></div>
            <span className="label">Unavailable</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default PhasePlotGrid;
